<template>
    <div class="text-left">
        <div class="row">
            <div class="col col-sm-12">
                <h3 class="font-weight-bolder mt-2">Sea Experience</h3>
            </div>

            <div class="col col-sm-12">
                <table class="table table-hover table-bordered table-template-1 table-layout-fixed text-small">
                    <thead>
                    <tr>
                        <th class="col-index">#</th>
                        <th class="col-code">Rank</th>
                        <th>Manning</th>
                        <th>Vessel Type</th>
                        <th>Vessel</th>
                        <th>Flag</th>
                        <th>Engine Capacity</th>
                        <th>Route</th>
                        <th>Sign In</th>
                        <th>Sign Off</th>
                        <th class="col-code">Reason</th>
                    </tr>
                    </thead>

                    <tbody>

                    <tr v-if="isLoading">
                      <td colspan="11">
                        <app-loading></app-loading>
                      </td>
                    </tr>

                    <template v-else>
                      <tr v-for="(seaExperience, index) in seaExperiences" :key="seaExperience.id">
                          <td>{{ index + 1 }}</td>
                          <td :title="seaExperience.rankName">
                              {{ seaExperience.rankAlias }}
                          </td>
                          <td :title="seaExperience.manningName">
                              {{ seaExperience.manningAlias }}
                          </td>
                          <td :title="seaExperience.vesselTypeName" >
                              {{ seaExperience.vesselTypeCode }}
                          </td>
                          <td :title="seaExperience.vesselTitle">
                              {{ seaExperience.vessel }}
                          </td>
                          <td>
                              {{ seaExperience.flag }}
                          </td>
                          <td>
                              {{ seaExperience.engineCapacity }}
                          </td>
                          <td>
                              {{ seaExperience.route }}
                          </td>
                          <td>
                              {{ seaExperience.signIn }}
                          </td>
                          <td>
                              {{ seaExperience.signOff }}
                          </td>
                          <td class="text-center" :title="seaExperience.reasonName">
                              {{ seaExperience.reasonCode }}
                          </td>
                      </tr>
                    </template>

                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions} from 'vuex';
    import AppLoading from "@/components/elements/AppLoading";
    import { vueAppMixin } from "@/mixins/vueAppMixin";


    export default {
        name: "SeaExperience",

      components: { AppLoading },

      mixins: [ vueAppMixin ],

        methods: {
            ...mapActions([ 'getCrewSeaExperiences', 'clearCrewSeaExperience' ]),
            initializeData() {
                this.getCrewSeaExperiences({
                    crewId: this.crew.id
                });
            }
        },

        computed: {
            ...mapGetters([ 'seaExperiences', 'crew' ])
        },

        created() {
            this.initializeData();
        },

      destroyed() {
          this.clearCrewSeaExperience();
      }
    }
</script>

<style scoped>

</style>
